module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/json-loader/index.js!./AirQualityIndex.json"));
	}, "lang-th");
}